import Link, { LinkProps } from 'next/link'
import { cva, RecipeVariantProps } from 'styled-system/css'

export const navItem = cva({
    base: {
        display: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        padding: '0.5rem 0.8rem',
        color: '$gray11',
        borderRadius: 10,
        transition: 'all 0.2s ease-in-out',
        cursor: 'pointer',
        fontSize: 14, // or 12
        '&:hover': {
            backgroundColor: '$primary2',
            color: '$primary9',
        },
        '@bp1': {
            display: 'flex',
        },
    },
    variants: {
        active: {
            true: {
                textDecoration: 'underline',
            },
        },
    },
})

import React, { FC, PropsWithChildren } from 'react'

export const NavItem: FC<PropsWithChildren<LinkProps & RecipeVariantProps<typeof navItem>>> = ({
    active,
    children,
    ...props
}) => {
    return (
        <Link className={navItem({ active })} {...props}>
            {children}
        </Link>
    )
}
